import { render, staticRenderFns } from "./IS.vue?vue&type=template&id=12d3e375&"
import script from "./IS.vue?vue&type=script&lang=js&"
export * from "./IS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports